/**
 * User service using Convex
 *
 * Replaces Supabase-based user operations
 */

/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return -- Convex generated types */

import { useQuery, useMutation } from 'convex/react'
import { api } from '../../convex/_generated/api'

/**
 * Hook to get current user profile
 */
export function useCurrentUser() {
  return useQuery(api.users.getCurrentUser)
}

/**
 * Hook to ensure user exists in Convex
 * Handles race condition between Clerk signup and webhook
 */
export function useEnsureUserExists() {
  return useMutation(api.users.ensureUserExists)
}

/**
 * Hook to update last login timestamp
 */
export function useUpdateLastLogin() {
  return useMutation(api.users.updateLastLogin)
}

/**
 * Hook to get current user's subscription
 */
export function useUserSubscription() {
  return useQuery(api.subscriptions.getCurrent)
}

